import { render } from "./InformeAgendas.vue?vue&type=template&id=f100ec28&scoped=true"
import script from "./InformeAgendas.vue?vue&type=script&lang=js"
export * from "./InformeAgendas.vue?vue&type=script&lang=js"

import "./InformeAgendas.vue?vue&type=style&index=0&id=f100ec28&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f100ec28"]])

export default __exports__